<template>
    <div id="new-busi-form" v-loading="loading">
        <!-- 我的档案 -->
        <div class="myRecords">
            <div class="myRecords-left">
                <div class="avatar-wrapper">
                    <img :src="photoUrl" class="user-avatar" />
                </div>
            </div>
            <div class="myRecords-right">
                <div class="r-right-top">
                    <span class="name">{{ vo.name }}</span>
                    &nbsp;&nbsp;
                    <span style="display: inline-block; margin-right: 10px">
                        <!-- {{ vo.sex === 1 ? '男' : '女' }} -->

                        <div v-if="vo.sex === 0" style="width: 34px; height: 26px; background: rgb(254, 240, 240); border-radius: 3px; display: flex; align-items: center; justify-content: flex-end">
                            <svg-icon style="margin-right: 10px; display: inline-block" icon-class="woman" />
                        </div>
                        <div v-if="vo.sex === 1" style="width: 34px; height: 26px; background: #e7f1fc; border-radius: 3px; display: flex; align-items: center; justify-content: flex-end">
                            <svg-icon style="margin-right: 10px; display: inline-block" icon-class="man" />
                        </div>
                    </span>
                    <span style="margin-right: 10px; display: inline-block">
                        <div v-if="vo.status === 1 || vo.status === 2 || vo.status === 3" style="line-height: 26px; text-align: center; font-size: 14px; color: #0ea04d; width: 52px; height: 26px; background: #e4f4eb; border-radius: 3px">
                            {{ vo.personStatus | statusFormat }}
                        </div>
                        <div v-if="vo.status === 4 || vo.status === 5" style="line-height: 26px; text-align: center; font-size: 14px; color: #ec8423; width: 52px; height: 26px; background: #f9eee4; border-radius: 3px">
                            {{ vo.personStatus | statusFormat }}
                        </div>
                    </span>
                </div>
                <div class="r-right-middle">
                    <span style="display: inline-block">员工编号：{{ vo.employeeNo }}</span>

                    <span v-if="vo.passenger.appointmnetInfos[0]" style="display: inline-block">部门：{{ vo.passenger.appointmnetInfos[0].department }}</span>
                    <span v-if="vo.passenger.appointmnetInfos[0]" style="display: inline-block">职务：{{ vo.passenger.appointmnetInfos[0].post }}</span>
                </div>
                <div class="r-right-buttom">
                    <span style="display: inline-block">电话：{{ vo.mobilePhone }}</span>
                    <span style="display: inline-block">邮箱：{{ vo.email }}</span>
                    <span style="display: inline-block">生日：{{ timeFormat(vo.birthday) }}</span>
                </div>
            </div>
        </div>
        <div class="new-head">
            <div class="head-left">
                <!-- <img src="/images/titleLogo.png" /> -->
                <div class="head-left-info">
                    <!-- <svg-icon style="font-size:44px" icon-class="wf_form" /> -->
                    <!-- <div class="head-title">{{ `人事档案 > 档案信息` }}</div> -->
                    <div class="header-tab">
                        <div class="tab-item" :class="activeTabId === 'ArchiveInfo' ? 'active' : ''" @click="handleHeaderTabClick('ArchiveInfo')">基本信息</div>
                        <div class="tab-item" :class="activeTabId === 'AppointmnetInfos' ? 'active' : ''" @click="handleHeaderTabClick('AppointmnetInfos')">任职信息</div>
                        <!-- <div class="tab-item" :class="activeTabId === 'TransferInfo' ? 'active' : ''" @click="handleHeaderTabClick('TransferInfo')">调离信息</div> -->
                        <div class="tab-item" :class="activeTabId === 'CertificatesInfo' ? 'active' : ''" @click="handleHeaderTabClick('CertificatesInfo')">相关学历及职业技能证书</div>
                        <!-- <div class="tab-item" :class="activeTabId === 'ExamineRecord' ? 'active' : ''" @click="handleHeaderTabClick('ExamineRecord')">考核记录</div> -->
                        <div class="tab-item" :class="activeTabId === 'workExperiences' ? 'active' : ''" @click="handleHeaderTabClick('workExperiences')">工作成长记录</div>
                        <div class="tab-item" :class="activeTabId === 'FamilyMembers' ? 'active' : ''" @click="handleHeaderTabClick('FamilyMembers')">家庭成员</div>
                        <!-- <div class="tab-item" :class="activeTabId === 'ArchiveChangeInfo' ? 'active' : ''" @click="handleHeaderTabClick('ArchiveChangeInfo')">变动信息</div> -->
                        <div class="tab-item" :class="activeTabId === 'ArchiveConInfos' ? 'active' : ''" @click="handleHeaderTabClick('ArchiveConInfos')">人事合同</div>
                        <!-- <div v-if="vo.passenger.wageInfo && vo.passenger.wageInfo.length > 0" class="tab-item" :class="activeTabId === 'WageInfo' ? 'active' : ''" @click="handleHeaderTabClick('WageInfo')">工资信息</div> -->
                        <!-- <div v-if="vo.passenger.vacateInfo && vo.passenger.vacateInfo.length > 0" class="tab-item" :class="activeTabId === 'VacateInfo' ? 'active' : ''" @click="handleHeaderTabClick('VacateInfo')">请休假情况</div> -->
                    </div>
                </div>
            </div>

            <!-- <div class="head-right"></div> -->
        </div>

        <div v-if="show" class="busi-box">
            <div class="busi-content" style="width: 100%">
                <!-- <div class="title-info">{{ busiInfo }}</div> -->
                <div id="busiComponents" class="busi-components" style="width: 100%">
                    <!-- 五个组件放在这 -->
                    <ArchiveInfo id="ArchiveInfo" ref="ArchiveInfo" :vo="vo" :is-mypersonal-records="isMypersonalRecords" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></ArchiveInfo>
                    <AppointmnetInfos id="AppointmnetInfos" ref="AppointmnetInfos" :is-mypersonal-records="isMypersonalRecords" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></AppointmnetInfos>
                    <CertificatesInfo id="CertificatesInfo" ref="CertificatesInfo" :is-mypersonal-records="isMypersonalRecords" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></CertificatesInfo>
                    <!-- <ExamineRecord id="ExamineRecord" ref="ExamineRecord" :vo="vo" :is-mypersonal-records="isMypersonalRecords" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></ExamineRecord> -->
                    <workExperiences id="workExperiences" ref="workExperiences" :is-mypersonal-records="isMypersonalRecords" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></workExperiences>
                    <FamilyMembers id="FamilyMembers" ref="FamilyMembers" :is-mypersonal-records="isMypersonalRecords" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></FamilyMembers>
                    <ArchiveConInfos id="ArchiveConInfos" ref="ArchiveConInfos" :vo="vo" :is-mypersonal-records="isMypersonalRecords" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></ArchiveConInfos>

                    <div class="footer">
                        <!-- <el-button @click="close">
                            <svg-icon style="color: red; margin-right: 5px" icon-class="glyphicon-off" />
                            关闭
                        </el-button>
                        <el-button v-show="canEdit === 1 && formType === 'update'" icon="el-icon-close" @click="edit(0)">取消</el-button>
                        <el-button v-show="canEdit === 1 && noEdit !== 'true'" :disabled="btnDisabled" @click="submit(true)">
                            <svg-icon style="margin-right: 5px" icon-class="save" />
                            保存关闭
                        </el-button> -->
                        <el-button v-show="canEdit === 1 && noEdit !== 'true'" type="primary" :disabled="btnDisabled" @click="submit(false)">
                            <svg-icon style="margin-right: 5px" icon-class="save" />
                            保存
                        </el-button>
                        <el-button v-show="canEdit === 0 && noEdit !== 'true'" icon="el-icon-edit" type="primary" @click="edit(1)">修改</el-button>
                    </div>
                </div>
            </div>
            <!-- 通用弹框 -->
            <select-dialog />
            <!-- 个别模块需要打开表单 -->
            <!-- <Basicform v-if="showForm" :title="formTitle" :win-width="moduleInfoT.winWidth" :win-height="moduleInfoT.winHeight" :module-code="moduleInfoT.moduleCode" :toolbar-btns="busiformBtns" :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened" :on-basic-form-before-submit="onBasicFormBeforeSubmit" :on-basic-form-submited="onBasicFormSubmited">
        <template #default="slotProps">
          <busi-form ref="busiform" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfoT" />
        </template>
</Basicform> -->
            <!-- 工作报告的分享 -->
            <!-- <button v-show="showShare" v-select-dialog="'staff'" class="xzry" multiple="true" :root-org-code="loginUser.orgCode" name="Share"></button> -->
            <!-- 工作报告回复 -->
            <!-- <replyDiaLog ref="repForm" :replay-vo="replayVo" :parent-vo="parentVo" /> -->
        </div>
    </div>
</template>

<script>
// import otherInfo from './components/otherInfo.vue'
// import replyDiaLog from './components/replyDiaLog.vue'
// import BasicInfoForm from './components/basic-info-form.vue'
// import RenzhiInfoForm from './components/renzhi-info-form.vue'
// import WorkExperienceForm from './components/work-experience-form.vue'
// import OtherInfoForm from './components/other-info-form.vue'
import { mapGetters, mapState } from 'vuex'
const moment = require('moment')
// 基本信息
import ArchiveInfo from './components/ArchiveInfo.vue'
// 任职信息
import AppointmnetInfos from './components/AppointmnetInfos.vue'
// 调离信息
import TransferInfo from './components/TransferInfo.vue'
// 相关学历及职业技能证书
import CertificatesInfo from './components/CertificatesInfo.vue'
// 考核记录
// import ExamineRecord from './components/ExamineRecord.vue'
// 工作简历/成长记录
import workExperiences from './components/workExperiences.vue'
// 家庭成员
import FamilyMembers from './components/FamilyMembers.vue'
// 变动信息
import ArchiveChangeInfo from './components/ArchiveChangeInfo.vue'
// 人事合同
import ArchiveConInfos from './components/ArchiveConInfos.vue'
// 工资信息
import WageInfo from './components/WageInfo.vue'
// 请休假情况
import VacateInfo from './components/VacateInfo.vue'
export default {
    name: 'Archive',
    filters: {
        statusFormat(val) {
            switch (Number(val)) {
                case 1:
                    return '实习'
                case 2:
                    return '试用'
                case 3:
                    return '正式'
                case 4:
                    return '退休'
                case 5:
                    return '离职'
            }
        }
    },
    components: {
        ArchiveInfo,
        AppointmnetInfos,
        TransferInfo,
        CertificatesInfo,
        // ExamineRecord,
        workExperiences,
        FamilyMembers,
        ArchiveChangeInfo,
        ArchiveConInfos,
        WageInfo,
        VacateInfo
        // otherInfo, replyDiaLog,
        // BasicInfoForm,
        // RenzhiInfoForm,
        // WorkExperienceForm,
        // OtherInfoForm,
        // changeInfoList
    },
    props: {},
    data() {
        return {
            voId: '',
            moduleInfo: { formTemplate: 'dcontent/busiformurl?vwtype=W&url=/rsgl/archiveInfo/addForm.html', winWidth: 1000, delUrl: 'rsgl/archiveInfo/delete', addNewUrl: 'rsgl/archiveInfo/addNew', insertUrl: 'rsgl/archiveInfo/insert', moduleCode: 'archiveInfo', listAdvSearchExpandPanel: 0, winHeight: 600, updateUrl: 'rsgl/archiveInfo/update', listDataUrl: 'rsgl/archiveInfo/listdata', getByIdUrl: 'rsgl/archiveInfo/getById', listAdvSearchAllFields: 0, openViewType: '0' },
            replayVo: {},
            parentVo: {},
            vo: {},
            isLoaded: true,
            canEdit: 0,
            fileList: [],
            showForm: false,
            show: false,
            formType: '',
            title: '',
            formUrl: '',
            showShare: false,
            newId: '',
            moduleInfoT: {},
            noEdit: '',
            btnDisabled: false,
            busiInfo: '人员档案信息',
            row: {},
            loginUser: this.$store.getters.loginUser,
            busiformBtns: [],
            formTitle: '',
            uploadFiles: [],
            formItem: {},
            addChangeUpdate: false,
            tableHeaderBgColor: '#f1f5fb!important',
            activeTabId: 'ArchiveInfo',
            urlT: process.env.VUE_APP_BASE_API,
            photoUrl: '',
            isMypersonalRecords: true // 当前是否“我的档案”标识，用作区分部分不可编辑字段
        }
    },
    computed: {
        ...mapGetters(['sidebar', 'avatar', 'device', 'loginUser', 'organList', 'routes'])
    },
    watch: {},
    created() {
        window.addEventListener('beforeunload', (event) => {
            if (window.opener && window.opener.loadList) {
                window.opener.loadList()
            }
        })
        this.$bus.emit('showNavSearch', false)
    },

    beforeDestroy() {
        this.$bus.emit('showNavSearch', true)
    },
    mounted() {
        this.vo = {}
        this.getListdata()
        this.photoUrl = this.avatar
    },
    methods: {
        timeFormat(val) {
            return val ? moment(new Date(val)).format('YYYY.MM.DD') : ''
        },
        getListdata() {
            // 通过当前登录人帐号查找人事档案信息
            this.$http({
                url: this.moduleInfo.listDataUrl,
                method: 'POST',
                params: {
                    urlsearch: 'account:' + this.loginUser.personAccount
                }
            }).then((res) => {
                console.log(res, 'res')
                if (res.code === 'success') {
                    this.getVo(res.body.pageInfo.list[0].id, this.moduleInfo)
                }
            })
        },
        // initScroll() {
        //     var tabs = document.querySelectorAll('.tab-item')
        //     var sections = document.querySelectorAll('.table-gap')
        //     function updateTabs() {
        //         console.log('cccc', tabs, sections)
        //         var activeTab = null

        //         // 遍历每个section和tab，找到当前应该激活的tab
        //         for (var i = 0; i < sections.length; i++) {
        //             var sectionTop = sections[i].getBoundingClientRect().top
        //             if (sectionTop >= 0 && sectionTop <= window.innerHeight) {
        //                 // 如果section在视口中，则激活对应的tab
        //                 activeTab = tabs[i]
        //                 break
        //             }
        //         }

        //         // 清除所有tab的激活状态，并激活找到的tab
        //         tabs.forEach(function(tab) {
        //             tab.classList.remove('active')
        //         })
        //         if (activeTab) {
        //             activeTab.classList.add('active')
        //         }
        //     }
        //     const box = document.querySelector('#new-busi-form')
        //     // 监听滚动事件并更新tabs
        //     box.addEventListener('scroll', updateTabs)

        //     // 初始时也执行一次，确保页面加载时选中的tab是正确的
        //     updateTabs()
        // },
        // addUploadFiles(formItem, fileList) {
        //     this.formItem = formItem
        //     this.uploadFiles = fileList
        // },
        // onSelectStaffCompleted(selectedNodes, attr) {
        //     var selectedId = ''
        //     var _this = this
        //     const list = []
        //     // 部门id/名字 //人员id/名字
        //     for (var i = 0; i < selectedNodes.length; i++) {
        //         const newobj = {}
        //         const obj = selectedNodes[i]
        //         newobj.inquirerId = obj.personId
        //         newobj.inquirerName = obj.name
        //         newobj.inquirerDeptId = obj.orgId
        //         newobj.inquirerDeptName = obj.orgFullName.split('-')[1]
        //         list.push(newobj)
        //     }
        //     // 列分享及表单内分享
        //     selectedId = _this.vo.id
        //     // 调用后台接口
        //     _this.$http({
        //         method: 'post',
        //         url: '/gzbg/jobReport/reportShare',
        //         params: {
        //             reportIds: selectedId
        //         },
        //         data: list
        //     }).then((res) => {
        //         if (res.code === 'success') {
        //             _this.$message.success(res.message)
        //             setTimeout(() => {
        //                 location.reload()
        //             }, 500)
        //         } else {
        //             _this.$message.error(res.message)
        //         }
        //     })
        // },
        // reply() {
        //     this.$http({
        //         method: 'post',
        //         url: '/gzbg/reply/addNew'
        //     }).then((res) => {
        //         if (res.code === 'success') {
        //             this.replayVo = res.body.vo
        //             this.replayVo.reportId = this.vo.id
        //             this.$http({
        //                 method: 'get',
        //                 url: '/gzbg/jobReport/getById',
        //                 params: {
        //                     id: this.replayVo.reportId
        //                 }
        //             }).then(res => {
        //                 if (res.code === 'success') {
        //                     this.parentVo = res.body.vo
        //                     this.$refs.repForm.isShow = true
        //                 }
        //             })
        //         } else {
        //             this.$message.error(res.message)
        //         }
        //     })
        // },
        // shareItem() {
        //     document.querySelector('.xzry').click()
        // },
        // cellClick(row) {
        //     this.showForm = true
        //     this.formTitle = '年申记录'
        //     this.busiformBtns = [
        //         {
        //             id: 'btn_close',
        //             btnName: '关 闭',
        //             btnIcon: 'close',
        //             btnClick: 'closeDialog',
        //             btnPermission: '',
        //             btnType: ''
        //         }
        //     ]

        //     this.moduleInfoT.getByIdUrl = 'zzgl/certCheckRecord/getById'
        //     this.moduleInfoT.moduleCode = 'certCheckRecord'
        //     this.moduleInfoT.formTemplate = '#/dcontent/vuebusiform/W/zzgl.certCheckRecord.form1.vue?sysCode='
        //     this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfoT.formTemplate)
        //     this.$nextTick(() => {
        //         this.$bus.emit('openBusiform', this.moduleInfoT, row, 0, (res) => { })
        //     })
        // },
        reloadList() {
            if (this.formType === 'addNew') {
                location.href = location.href.replace('voId=', 'voId=' + this.newId)
            }
            this.show = false
            this.getListdata()
        },
        submit(falg, callBack) {
            this.childComponentFormValidate(falg, callBack)
        },
        onBasicFormBeforeSubmit($scope, vo, defer) {
            defer.resolve(true)
        },
        onBasicFormSubmited($scope, callBack) {
            if (callBack) {
                callBack()
            }
        },

        childComponentFormValidate(falg, callBack) {
            var _this = this
            console.log('this:', this)
            this.formValidate(
                () => {
                    new Promise((resolve, reject) => {
                        // _this.$refs.ArchiveInfo.onBasicFormBeforeSubmit(_this, _this.vo, { resolve, reject })
                        _this.onBasicFormBeforeSubmit(_this, _this.vo, { resolve, reject })
                    })
                        .then((res) => {
                            _this.btnDisabled = true
                            let serveiceUrl = ''
                            let serveiceMethod
                            if (!_this.addChangeUpdate) {
                                serveiceUrl = this.formType === 'addNew' ? this.moduleInfo.insertUrl : this.moduleInfo.updateUrl
                                serveiceMethod = this.formType === 'addNew' ? 'POST' : 'PUT'
                            } else {
                                serveiceUrl = this.moduleInfo.updateUrl
                                serveiceMethod = 'PUT'
                            }
                            this.canEdit = 0
                            new Promise((resolve, reject) => {
                                _this
                                    .$http({
                                        url: serveiceUrl,
                                        method: serveiceMethod,
                                        data: _this.vo
                                    })
                                    .then((res) => {
                                        _this.btnDisabled = false
                                        if (res.code === 'success') {
                                            _this.$message.success(res.message)
                                            if (!_this.addChangeUpdate) {
                                                if (this.formType === 'addNew') {
                                                    _this.newId = res.body.vo.id
                                                }
                                            }
                                            // if (this.vo.idPhotoName) {
                                            //     this.$refs.ArchiveInfo.uploadfile()
                                            // }

                                            // 如果有附件上传
                                            let uploadAttach = []
                                            let array = []
                                            if (_this.$refs.ArchiveInfo.$refs.idPhoto) {
                                                uploadAttach = _this.$refs.ArchiveInfo.$refs.idPhoto.updateFileList
                                                _this.$refs.ArchiveInfo.$refs.idPhoto.updateFileList.forEach((item) => {
                                                    const fd = new FormData()
                                                    // fd.append('file', item.raw)
                                                    // fd.append('module', _this.moduleInfo.moduleCode)
                                                    // fd.append('attachsSize', item.size)
                                                    // fd.append('busiDataId', _this.vo.id)
                                                    // fd.append('attachsType', 'ATTACH')
                                                    // fd.append('attachsName', item.name)
                                                    // fd.append('uploadBy', _this.loginUser.personName)
                                                    // fd.append('uploadById', _this.loginUser.userId)

                                                    fd.append('file', item.raw)
                                                    fd.append('id', res.body.vo.id)
                                                    fd.append('dataField', 'idPhoto')
                                                    fd.append('nameField', 'certificatesName')
                                                    array.push(
                                                        this.$http({
                                                            method: 'PUT',
                                                            url: _this.moduleInfo.updateUrl.replace('update', 'upload'),
                                                            data: fd
                                                        })
                                                    )
                                                })
                                            }

                                            if (_this.$refs.CertificatesInfo.uploadAttachList && _this.$refs.CertificatesInfo.uploadAttachList.length > 0) {
                                                console.log(_this.$refs.CertificatesInfo.uploadAttachList, '_this.$refs.CertificatesInfo.uploadAttachList')

                                                uploadAttach.push(..._this.$refs.CertificatesInfo.uploadAttachList)
                                                _this.$refs.CertificatesInfo.uploadAttachList.forEach((item) => {
                                                    const fd = new FormData()
                                                    fd.append('file', item.raw)
                                                    fd.append('id', item.rowId)
                                                    fd.append('dataField', 'certificatesEnclosure')
                                                    fd.append('nameField', 'certificatesFileName')
                                                    array.push(
                                                        this.$http({
                                                            method: 'PUT',
                                                            url: 'rsgl/certificatesInfo/upload',
                                                            data: fd
                                                        })
                                                    )
                                                })
                                            }
                                            if (_this.$refs.ArchiveConInfos.uploadAttachList && _this.$refs.ArchiveConInfos.uploadAttachList.length > 0) {
                                                console.log(_this.$refs.ArchiveConInfos.uploadAttachList, '_this.$refs.ArchiveConInfos.uploadAttachList')

                                                uploadAttach.push(..._this.$refs.ArchiveConInfos.uploadAttachList)
                                                _this.$refs.ArchiveConInfos.uploadAttachList.forEach((item) => {
                                                    const fd = new FormData()
                                                    fd.append('file', item.raw)
                                                    fd.append('id', item.rowId)
                                                    fd.append('dataField', 'conFile')
                                                    fd.append('nameField', 'fileName')
                                                    array.push(
                                                        this.$http({
                                                            method: 'PUT',
                                                            url: 'rsgl/conInfo/upload',
                                                            data: fd
                                                        })
                                                    )
                                                })
                                            }
                                            if (uploadAttach.length > 0) {
                                                Promise.all(array).then((res) => {
                                                    if (res.length === uploadAttach.length) {
                                                        resolve()
                                                    }
                                                })
                                            } else {
                                                resolve()
                                            }
                                            // if (_this.uploadFiles.length > 0) {
                                            //     _this.uploadFiles.forEach(item => {
                                            //         const uploadingFile = item
                                            //         const config = {
                                            //             onUploadProgress: progressEvent => {
                                            //                 const complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
                                            //                 uploadingFile.progress = complete
                                            //                 _this.$forceUpdate()
                                            //             }
                                            //         }
                                            //         let fieldUploadUrl = ''
                                            //         if (_this.formItem.downloadUrl !== undefined && _this.formItem.downloadUrl !== null && _this.formItem.downloadUrl !== '') {
                                            //             fieldUploadUrl = _this.formItem.downloadUrl.replace('/downloadById', '/upload').replace('/download', '/upload')
                                            //         }
                                            //         const nameField = this.formItem.nameField
                                            //         const dataField = this.formItem.propName
                                            //         this.$app.upload(fieldUploadUrl, item.raw, { 'id': _this.formItem.pid || this.vo.id, 'nameField': nameField, 'dataField': dataField }, config)
                                            //     })
                                            //     resolve()
                                            // } else {
                                            //     resolve()
                                            // }
                                        } else {
                                            _this.$message.error(res.message)
                                        }
                                    })
                            }).then((res) => {
                                if (falg) {
                                    if (callBack) {
                                        callBack(true)
                                    }
                                    _this.onBasicFormSubmited()
                                    _this.addChangeUpdate = true
                                    _this.close()
                                } else {
                                    _this.onBasicFormSubmited(_this, _this.reloadList)
                                }
                            })
                        })
                        .catch((error) => {
                            this.$message.error(error)
                        })
                },
                () => {
                    if (callBack) {
                        callBack(false)
                    }
                }
            )
        },
        close() {
            window.close()
        },
        edit(val) {
            this.show = false
            this.canEdit = val
            this.$nextTick(() => {
                this.show = true
            })
            this.$forceUpdate()
        },
        getVo(id, moduleInfo) {
            if (id) {
                this.$http({
                    method: 'get',
                    url: moduleInfo.getByIdUrl,
                    params: {
                        id: id
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.vo = res.body.vo
                        this.isLoaded = false
                    }
                    this.show = true
                })
            } else {
                this.$http({
                    method: 'post',
                    url: moduleInfo.addNewUrl
                }).then((res) => {
                    if (res.code === 'success') {
                        this.vo = res.body.vo
                        this.show = true
                        this.isLoaded = false
                        if (this.title === '人事档案') {
                            // this.vo.passenger.appointmnetInfos = []
                            // this.vo.passenger.workExperiences = []
                            // this.vo.passenger.certificatesInfos = []
                            // this.vo.passenger.conInfos = []
                            // this.vo.passenger.bankcardInfos = []
                        }
                    }
                })
            }
            // if (this.title === '人事档案') {
            //     this.fileList = {
            //         certificatesInfo: [],
            //         archiveInfo: []
            //     }
            // }
        },
        // handleHeaderTabClick(tabId) {
        //     this.activeTabId = tabId
        //     // document.getElementById(tabId).scrollIntoView()
        //     document.getElementById(tabId).scrollIntoView({ block: 'start', behavior: 'smooth' })
        // }
        handleHeaderTabClick(tabId) {
            this.activeTabId = tabId
            var container = document.getElementById('busiComponents')
            var targetElement = document.getElementById(tabId)

            if (container && targetElement) {
                // 滚动到 targetElement 的顶部
                // 注意：这里假设 container 是 targetElement 的滚动容器，并且 container 的 position 不是 static
                // 如果 container 的 position 是 static，则可能需要调整计算方式
                container.scrollTop = targetElement.offsetTop - 260

                // 如果 targetElement 上面有 padding 或 border，您可能需要从 offsetTop 中减去这些值
                // 但这通常不需要，因为 offsetTop 已经考虑了这些

                // 如果需要平滑滚动，可以添加平滑滚动的逻辑
            }
        }
    }
}
</script>
<style scoped lang="scss">
/deep/.el-table__body-wrapper::-webkit-scrollbar {
    height: 8px;
}

/deep/.el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 12px;
    /*滚动条的背景区域的圆角*/
}

/deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 12px;
    /*滚动条的圆角*/
    background-color: #f5f5f5;
    /*滚动条的背景颜色*/
}

/deep/.el-form .el-table__body .tdlbl {
    text-align: left !important;
    background: unset !important;
}

#new-busi-form {
    height: 100%;
    background: #fff;
    padding: 0 10px;
    // min-width: 1360px;

    .new-head {
        height: 68px;
        display: flex;
        justify-content: space-between;
        // padding: 0 20px;
        background: white;
        align-items: center;

        .head-left {
            display: flex;
            align-items: center;

            img {
                width: 44px;
                height: 44px;
            }

            .head-left-info {
                margin-left: 10px;

                .head-title {
                    font-size: 14px;
                    color: #999999;
                    padding-top: 10px;
                    padding-left: 5px;
                }
            }
        }

        .head-right {
            min-width: 400px;
            text-align: right;
        }
    }

    .busi-box {
        // height: calc(100% - 68px);
        // overflow: auto;
        // padding-top: 20px;
        // padding-left: 10px;
        // padding: 20px;

        .busi-content {
            width: 1200px;
            // padding-bottom: 20px;
            background: white;
            min-height: calc(100vh - 400px);
            margin: 0px auto;
            // box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);

            .title-info {
                height: 93px;
                text-align: center;
                line-height: 93px;
                font-size: 24px;
                color: #000000;
            }

            .busi-components {
                // padding: 0 100px;
                width: 100%;
                // height: calc(100vh - 385px);
                // overflow: auto;
            }

            #busiComponents {
                scroll-behavior: smooth; /* 添加平滑滚动效果 */
                height: calc(100vh - 405px);
                overflow-y: auto;
            }
        }
    }

    /* 设置滚动条thumb（轨道）的颜色 */
    .busi-box::-webkit-scrollbar {
        background-color: #f0f2f5;
        width: 8px;
    }

    /* 设置滚动条thumb（滑块）的颜色 */
    .busi-box::-webkit-scrollbar-thumb {
        border-radius: 12px;
    }

    /* 设置滚动条hover时thumb的颜色 */
    .busi-box:hover.busi-box::-webkit-scrollbar-thumb {
        background-color: #d5d6d8;
    }

    /deep/.el-table .el-table__header-wrapper .el-table__header thead th {
        background: #f2f5fb !important;
    }
}
</style>

<style scoped lang="scss">
@import '@/wapp/common/styles/variables.module.scss';

.table-gap {
    // margin-top: 20px;
    margin-bottom: 20px;
}

.header-tab {
    display: flex;
    // margin-top: 10px;
    height: 38px;
    line-height: 38px;

    .tab-item {
        position: relative;
        margin-right: 10px;
        padding: 0 5px;
        // color: #666;
        color: #000000;
        display: inline-block;
        width: auto;
        white-space: nowrap;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        cursor: pointer;
    }

    .active {
        position: relative;
        color: var(--subjectColor);

        &::after {
            content: '';
            position: absolute;
            bottom: 3px;
            left: 0px;
            width: 100%;
            height: 1px;
            background: var(--subjectColor);
        }
    }
}

// /deep/ .tdw13{
//     width: 13% !important;
//     text-align: right;
// }
// /deep/ .tdw20 {
//     width: 20% !important;
// }
/deep/.el-form .el-table__body td.tdw20 {
    width: 20% !important;
}

/deep/.el-form .el-table__body td.tdw13 {
    width: 13% !important;
}

/deep/ .el-form .el-table__body {
    min-width: 100%;
}

.myRecords {
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    .myRecords-left {
        margin-right: 20px;
    }
    .myRecords-right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        padding: 1px 0;
        .r-right-top {
            display: flex;
            font-size: 15px;
            flex-direction: row;
            align-items: center;
            margin-right: 10px;
            margin-bottom: 10px;
            .name {
                font-weight: 600;
                font-size: 24px;
            }
        }
        .r-right-middle {
            color: #666666;
            font-size: 13px;
            span {
                margin-right: 10px;
                min-width: 190px;
            }
        }
        .r-right-buttom {
            color: #666666;
            font-size: 13px;
            span {
                margin-right: 10px;
                min-width: 190px;
            }
        }
    }
    .avatar-wrapper {
        /* margin-top: 5px; */
        // position: relative;
        // float: right;

        .user-avatar {
            cursor: pointer;
            width: 100px;
            height: 100px;
            border-radius: 15%;
            // margin-top: 10px;
            border: #fff solid 2px;
        }

        .el-icon-caret-bottom {
            cursor: pointer;
            font-size: 12px;
            float: right;
            line-height: $headerHeight;
        }
    }
}

/* 滚动条 */
/* 应用于具有custom-scrollbar 类的元素的滚动条样式 */
#busiComponents::-webkit-scrollbar {
    width: 6px; /* 设置滚动条宽度 */
    height: 6px; /* 如果你想要设置垂直滚动条的高度，也可以在这里设置 */
}

/* 滚动条的轨道样式 */
#busiComponents::-webkit-scrollbar-track {
    /* background: transparent; 或者设置为背景色 */
}

/* 滚动条的手柄（滑块）样式 */
#busiComponents::-webkit-scrollbar-thumb {
    background-color: #ccc; /* 设置滚动条颜色 */
    border-radius: 10px; /* 可选：设置滚动条手柄的圆角 */
    /* 可选：添加一些阴影或过渡效果来增强视觉体验 */
    /* box-shadow: inset 0 0 6px rgba(0,0,0,0.3); */
    /* transition: background 0.3s ease-in-out; */
}

/* 当鼠标悬停在滚动条手柄上时，可以更改样式 */
#busiComponents::-webkit-scrollbar-thumb:hover {
    background-color: #ccc; /* 悬停时的颜色 */
}

/* 滚动条的按钮（通常在水平滚动条的两端）的样式，如果需要的话 */
#busiComponents::-webkit-scrollbar-button {
    display: none;
}

/* 滚动条的角落（两个滚动条交汇的地方）的样式，如果需要的话 */
#busiComponents::-webkit-scrollbar-corner {
    background: transparent; /* 设置角落的背景色 */
}
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
